/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Gift_CardsInputs */

const es_footer_link_gift_cards = /** @type {(inputs: Footer_Link_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas de regalo`)
};

const gl_footer_link_gift_cards = /** @type {(inputs: Footer_Link_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarxetas de agasallo`)
};

const en_footer_link_gift_cards = /** @type {(inputs: Footer_Link_Gift_CardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gift cards`)
};

/**
* | output |
* | --- |
* | "Gift cards" |
*
* @param {Footer_Link_Gift_CardsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_gift_cards = /** @type {((inputs?: Footer_Link_Gift_CardsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Gift_CardsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_gift_cards(inputs)
	if (locale === "en") return en_footer_link_gift_cards(inputs)
	return es_footer_link_gift_cards(inputs)
});